<template>
	<div class="zone">
		<div></div>
		<div class="name">{{ value.name }}</div>
		<div></div>
		<div></div>
		<div class="btn-group">
			<button-icon-loading @click.native.stop="deleteZone(value.id)" :loading="loading" icon="trash" class="btn-delete"/>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'deleteZone',
		'loading'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/rows/ReadingsWidgetAlertParametersZone.vue